import { render, staticRenderFns } from "./MtdTransactionCategory.vue?vue&type=template&id=ad5e5dd0&scoped=true&"
import script from "./MtdTransactionCategory.vue?vue&type=script&lang=js&"
export * from "./MtdTransactionCategory.vue?vue&type=script&lang=js&"
import style0 from "./MtdTransactionCategory.vue?vue&type=style&index=0&id=ad5e5dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5e5dd0",
  null
  
)

export default component.exports